import {Location} from '@angular/common';
import {Component, EventEmitter, Output, ViewContainerRef} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs/Observable';
import * as _ from 'underscore';
import {Configuration} from '../../shared/services/configuration';
import {HttpClientCustom} from '../../shared/services/http.client';
import {SharedData} from '../../shared/sharedData';
import {ToasterComponent} from '../../toasterComponent/toasterComponent';


@Component({
    selector: 'AddParentOrganization',
    templateUrl: 'addParentOrganization.html',
    outputs: ['cancelEvent']
})
export class AddParentOrganizationComponent {

    @Output() public addOrgEvent = new EventEmitter();
    public _baseUrl: any;
    public orgTypeData: any = [];
    public currentEmployee: any;
    public type: any = 'ADD';
    public asl: boolean = false;

    public data: any;
    public cancelEvent: any = new EventEmitter();
    // public addOrgEvent: any = new EventEmitter();
    public myData: any;
    public arrayOfStrings = [];
    public categoryData: any = [];
    public myForm: FormGroup;
    public previousSearchKey;
    public orgTypeModel: any;

    public warning: any = 'Please type to select';
    public primarySupervisorModel: any;
    public hrSpocModel: any;
    public ccAdmin: any;
    public ccManager: any;
    public leaveAdministrator: any;
    public oldValue = null;
    public orgCat = null;
    // tslint:disable-next-line:member-ordering
    public payload = {
        searchString: '',
        excludeEmpIds: []
    };
    public disableButton: any = false;
    public parentOrg: any;
    public childIds: any;
    public orgData = {
        id: null,
        level: null,
        orgName: "",
        orgUnitCode: "",
        houEmployeeId: null,
        hrSpocId: null,
        orgType: null,
        parentId: null,
        description: null,
        mission: null,
        vision: null,
        status: null,
        orgTypeMappings: [],
        ccAdminId: null,
        ccManagerId: null,
        leaveAdministratorId: null,
        category: {code: null},
        childIds: [],
        parentOrgName: null,
        orgNameLocale: null,
        descriptionLocale: null
    };
    key: any;
    public orgFilter = {
        nameOrCode: null,
        excludedIds: [],
        page: 1,
        pageSize: 10
    }

    public parent;

    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public activeModal: NgbActiveModal,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public router: Router,
        public _location: Location,
        public share: SharedData,
        public _toaster: ToasterComponent,
        public translate: TranslateService,
        vcr: ViewContainerRef) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        let data: any = this.share.getData();
        this.type = data.type;
        this.share.saveData({mainOrg: this.share.getData(), type: 'Edit'});
        if (this.type === 'EDIT') {
            this.getOrgDataToUpdate(data);
        } else {
            this.data = {};
        }
    }

    //Get OrgData to edit

    getOrgDataToUpdate(data) {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/orgUnit/' + data.org.id;
        self.http.get(url).subscribe((result) => {
            this.orgData = result.data;
            if (this.orgData.houEmployeeId != null) {
                this.getEmployeeById(this.orgData.houEmployeeId, 'hou');
            }
            if (this.orgData.hrSpocId != null) {
                this.getEmployeeById(this.orgData.hrSpocId, 'hrSpoc');
            }
            if (this.orgData.ccAdminId != null) {
                this.getEmployeeById(this.orgData.ccAdminId, 'ccAdmin');
            }
            if (this.orgData.ccManagerId != null) {
                this.getEmployeeById(this.orgData.ccManagerId, 'ccManager');
            }
            if (this.orgData.leaveAdministratorId != null) {
                this.getEmployeeById(this.orgData.leaveAdministratorId, 'leaveAdministrator');
            }
            if (this.orgData.category != null) {
                this.orgCat = this.orgData.category.code;
            }

            if (this.orgData.childIds != null) {
                this.orgFilter.excludedIds = this.orgData.childIds;
                this.orgFilter.excludedIds.push(data.org.id);
            }

            if (this.orgData.parentOrgName != null) {
                this.parent = this.orgData.parentOrgName;
            }

            if(result.data.orgType != null){
                url = self._baseUrl + 'v1/webAdmin/orgUnit/orgType/' + result.data.orgType.id;
                self.http.get(url).subscribe((res) => {
                    this.orgTypeModel = res.data.orgUnitTypeName;
                }, (error) => {
                    console.log('Error while fetching org type');
                });
            }
        });
    }

    // Get employee by id
    public getEmployeeById(parm, type) {
        let url = this._baseUrl + 'v1/webAdmin/employee/getEmployee' + '?employeeId=' + parm;
        this.http.get(url).subscribe((result) => {
            if (type === 'hou') {
                this.primarySupervisorModel = result.displayName;
            }
            if (type === 'hrSpoc') {
                this.hrSpocModel = result.displayName;
            }
            if (type === 'ccAdmin') {
                this.ccAdmin = result.displayName;
            }
            if (type === 'ccManager') {
                this.ccManager = result.displayName;
            }
            if (type === 'leaveAdministrator') {
                this.leaveAdministrator = result.displayName;
            }


        }, (error) => {
            console.log('saveEmployee error caught', error);
        });
    }

    public getOrgTree() {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/orgUnit';
        self.http.get(url).subscribe((result) => {
            self.orgData = result.data;
        }, (error) => {
            console.log('Org Tree error catch', error);
        });

    }

    // To get list of Organization based on keyword
    public orgTypeObservableSource = (keyword: any): Observable<any[]> => {
        if (keyword) {
            let url = this._baseUrl + 'v1/webAdmin/orgUnit/orgType/autoComplete';
            url += '?name=' + keyword;
            if (keyword) {
                return this.http.get(url)
                    .map((res) => {
                        return res;
                    }, (error) => {
                        console.log('catch orgUnitType Error' + error);
                        return Observable.of([]);
                    });
            } else {
                return Observable.of([]);
            }
        } else {
            return Observable.of([]);
        }
    }

    public getIdsWithPayload(keyword) {
        let payload = {
            searchString: null,
            excludeEmpIds: []
        };
        payload.searchString = keyword;
        let everythingButTheNulls = _.compact(payload.excludeEmpIds);
        payload.excludeEmpIds = [];
        payload.excludeEmpIds = everythingButTheNulls;
        return payload;
    }

    // ObservableSource
    // To get list of supervisor based on keyword
    public employeeObservableSource(keyword: any) {
        if (keyword) {
            let url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
            let payload: any = this.getIdsWithPayload(keyword);
            return this.http.post(url, payload)
                .map((res) => {
                    return res;
                }, (error) => {
                    console.log('error while seaching employee' + error);
                });
        } else {
            return Observable.of([]);
        }
    }

    public hrrObservableSource(keyword: any) {
        if (keyword) {
            let url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
            let payload: any = this.getIdsWithPayload(keyword);
            return this.http.post(url, payload)
                .map((res) => {
                    return res;
                }, (error) => {
                    return Observable.of([]);
                });
        } else {
            return Observable.of([]);
        }
    }

    // orgCatObservableSource

    public orgCatObservableSource(keyword: any) {
        if (keyword && keyword.trim()) {
            let url = this._baseUrl + 'v1/webAdmin/orgUnit/orgCategory/autoComplete';
            url += '?codeOrName=' + keyword;
            // let payload: any = this.getIdsWithPayload(keyword);
            return this.http.get(url)
                .map((res) => {
                    return res.content;
                }, (error) => {
                    return Observable.of([]);
                });
        } else {
            return Observable.of([]);
        }
    }

    // Formatter
    public orgTypeFormatter(data: any): string {
        return `${data.orgUnitTypeName}`;
    }

    public autoCompleteListOrgTypeFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.orgUnitTypeName}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    public autoCompleteListFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.displayName}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    public autoCompleteOrgCat = (data: any): SafeHtml => {
        let html = `<span>${data.code}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    public autoCompleteOrgName = (data: any): SafeHtml => {
        let html = `<span>${data.orgName}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    public changeOldValue() {
        let self = this;
        self.oldValue = null;
    }

    // when auto-complete value is selected this method fires and payload create
    public gotNewValue(e, type) {
        setTimeout(() => {
            this.changeOldValue();
        }, 1000);
        if (_.isObject(e)) {
            if (this.oldValue === type) {
                return;
            }
        } else if (e === '') {
            e = {id: null, name: null};
            this.oldValue = type;
        } else {
            return;
        }
        if (type === 'orgType') {
            if(this.orgData.orgType == null){
                this.orgData.orgType = {};
            }
            this.orgData.orgType.id = e.id;
            this.orgData.level = e.level;
        }
        if (type === 'primary') {
            this.orgData.houEmployeeId = e.id;
        }
        if (type === 'hrSpoc') {
            this.orgData.hrSpocId = e.id;
        }
        if (type === 'ccAdmin') {
            this.orgData.ccAdminId = e.id;
        }
        if (type === 'ccManager') {
            this.orgData.ccManagerId = e.id;
        }
        if (type === 'leaveAdministrator') {
            this.orgData.leaveAdministratorId = e.id;
        }
        if (type === "orgCat") {
            this.orgData.category = e;
        }
        if (type === "parent") {
            this.orgData.parentId = e.id;
        }
    }

    public isString(value) {
        return typeof value === 'string' || value instanceof String;
    }

    public getSelectedOrgTypeName() {
        if (this.isString(this.orgTypeModel)) {
            return this.orgTypeModel;
        } else {
            return this.orgTypeModel.orgUnitTypeName;
        }
    }

    // Save organization
    public saveOrgData() {
        if (!this.orgData.orgUnitCode || !this.orgData.orgUnitCode.trim()) {
            this.translate.get('PLEASE_ENTER_ORGANIZATION_CODE_TO_CONTINUE').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.orgData.orgName || !this.orgData.orgName.trim()) {
            this.translate.get('PLEASE_ENTER_ORGANIZATION_NAME_TO_CONTINUE').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        }

        if (!this.orgTypeModel) {
            this.translate.get('PLEASE_SELECT_ORG_TYPE').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        }
        this.disableButton = true;
        if (this.type === 'ADD') {
            let url = this._baseUrl + 'v1/webAdmin/orgUnit';
            if(this.orgData.category.code == null){
                this.orgData.category = null;
            }
            this.http.post(url, this.orgData).subscribe((result) => {
                if (result.success) {
                    this.activeModal.close({data: result.data, orgTypeName: this.getSelectedOrgTypeName()});
                } else {
                    this.translate.get('errorWhileAddingOrg').subscribe((msg) => {
                        this._toaster.showError(msg);
                    });
                    for (let val of result.errorMessages) {
                        this._toaster.showError(val);
                    }
                    this.disableButton = false;
                }
            }, (error) => {
                console.log('saveOrg error caught', error);
                this.disableButton = false;
            });
        } else {
            let url = this._baseUrl + 'v1/webAdmin/orgUnit/' + this.orgData.id;
            this.http.put(url, this.orgData).subscribe((result) => {
                if (result.success) {
                    this.activeModal.close({data: result.data, orgTypeName: this.getSelectedOrgTypeName()});
                } else {
                    this.translate.get('errorWhileUpdateOrg').subscribe((msg) => {
                        this._toaster.showError(msg);
                    });
                    for (let val of result.errorMessages) {
                        this._toaster.showError(val);
                    }
                    this.disableButton = false;
                }
            }, (error) => {
                console.log('saveOrg error caught', error);
                this.disableButton = false;
            });
        }

    }

  // To get list of Organization based on keyword
  public organisationUnitObservable = (keyword: any): Observable<any[]> => {
    if (keyword && keyword.trim()) {
      //let encodedKeyword = encodeURIComponent(keyword);
      let url = this._baseUrl + 'v1/webAdmin/orgUnit/searchOrg';
        this.orgFilter.nameOrCode = keyword;
        console.log(this.orgFilter)
        return this.http.post(url, this.orgFilter)
          .map((res) => {
            console.log(res);
            if(res!=null && res.length>0){
                return res;
            }else{
              this.translate.get('noParentOrg').subscribe((msg) => {
                this._toaster.showWarning(msg);
              });
              res = []
              return res;
            }

          }, (error) => {
            console.log('catch orgUnitType Error' + error);
            return Observable.of([]);
          });

    } else {
      return Observable.of([]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tools/org/addParentOrganization.ts